var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-takt",style:(`
    ${!_vm.width && _vm.no_zoom?'width: calc(var(--workpackage_width) + 8px)':''}
    ${_vm.width?`width: ${_vm.width}`:''}
    `)},[_c('div',{staticClass:"statisitic-hover"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }